module.exports = __webpack_public_path__ + "media/promo/lum2021/images/1stm-6b6b2c8cde3c8efb9168bf291f8409aa.jpg";